import { Trash03, User01 } from '@untitled-ui/icons-react';

import { Avatar } from '../../../../../../components/avatar';
import { Badge } from '../../../../../../components/badge';
import { IconButton } from '../../../../../../components/buttons/icon-button';
import { DropdownMenu, DropdownMenuItem } from '../../../../../../components/dropdown-menu';
import { AnimatedDotsIcons } from '../../../../../../components/icons/animatedDotsIcons';
import { OrganizationUserRole } from '../../../../../../entity/api/organization-user';
import { tNamespace } from '../../../../../../services/translation';
import { getUserDefaults } from '../../../../../../shared/user';

const t = tNamespace('app.settings.organization.users');

export function UserComponent(props: {
  userInformation: {
    _id: string;
    firstName?: string | null;
    lastName?: string | null;
    email: string;
  };
  role: OrganizationUserRole;
  isOwner: boolean;
  onRemove: () => void;
  onEdit: () => void;
}) {
  const { userInformation, role, isOwner, onRemove, onEdit } = props;
  const user = {
    ...userInformation,
    ...getUserDefaults(userInformation),
  };

  return (
    <div className="flex items-center gap-2" key={user._id}>
      <Avatar icon={<User01 width={20} height={20} />} size="md" />
      <div className="flex flex-1 flex-col">
        <p className="font-body-2-m flex gap-1">
          {user.firstName}
          <span>{user.lastName}</span>
        </p>
        <p className="font-body-2-r text-branding-gray">{user.email}</p>
      </div>
      {role != null && (
        <Badge size="sm" color="accent">
          <span className="capitalize">{role}</span>
        </Badge>
      )}
      {isOwner && role !== OrganizationUserRole.Owner ? (
        <DropdownMenu
          trigger={
            <IconButton
              isDiv={true}
              size="xs"
              variant="ghost-neutral"
              icon={<AnimatedDotsIcons groupName="group/dots-icon" />}
            />
          }
          triggerClassName="group/dots-icon"
        >
          <DropdownMenuItem label={t('makeOwnerOfTheOrganization')} onClick={onEdit} />
          <DropdownMenuItem
            label={
              <div className="flex items-center gap-2">
                <Trash03 width={16} height={16} className="text-red-500" />
                <p className="text-red-500">{t('deleteFromOrganization')}</p>
              </div>
            }
            onClick={onRemove}
          />
        </DropdownMenu>
      ) : null}
    </div>
  );
}
